<template>
  <sl-amap class="map" :zoom="5" theme="whitesmoke" @ready="handleReady"></sl-amap>
</template>
<script>
import Poi from '@/components/sl-amap/components/amap-poi'
import { getStaticPath } from '@/util/request'
import { throttle } from '@/util'
import { wgs2gcj } from '@/util/map/proj'

export default {
  data() { //
    return {
      companies: [],
      brands: {},
      ready:false,
      map: null,
      poiManager:null,
      poiTpl: '<div class="sl-amap-poi" title="{companyName}"><i style="background-image:url({icon})"></i></div>',
      iwTpl: `<div class="sl-amap-popup"><h3>{companyName}</h3><div class="sl-amap-popup-wrap"><div class="sl-amap-popup-thumb" style="background-image:url({icon})"></div><div class="sl-amap-popup-cnt"><p><label>品牌：</label>{brandName}</p><p><label>地址：</label>{businessAddress}</p><p><span title="快递员数量"><i class="ivu-icon i-icon icon-kuaidiyuan"></i>{courierTotal}</span><span title="配送车数量" onclick="{link_to_car_map}"><i class="ivu-icon i-icon icon-car"></i>{carTotal}</p></span></div></div><i class="sl-amap-popup-arrow"></i><i class="sl-amap-popup-close" onclick="{close_iw}">×</i></div>`,
      visible: false
    }
  },
  beforeDestroy(){
    this.poiManager.destroy()
    this.map.destroy()
  },
  methods: {
    init() {
      this.visible = true
    },
    handleReady(map) {
      
      let linkToCarMap = '_sl_map_linkto_carmap_' + Date.now()
      window[linkToCarMap] = this.linkToCar.bind(this)

      this.poiManager = new Poi(map, {
        poiTpl: this.poiTpl,
        iwTpl: this.iwTpl,
        size: [48, 48],
        offset: [-16, -37],
        handlers:{
          'link_to_car_map':`window['${linkToCarMap}']({id})`
        }
      })
      map.on('moveend', this.update)

      map.on('zoomend', this.update)
      map.on('resize', this.update)

      this.map = map
      if( window.location.search ){
        let {lat , lng , zoom = 8 } = this.$route.query
        if( lat && lng ){
          setTimeout(()=>{
            map.setZoomAndCenter(zoom ,  new AMap.LngLat(lng, lat))
          },800)
        }

      }
      this.fetchBrand()
    },

    update() {
      if (this.ready) {
        //this.fetchCompany(this.poiManager.getBounds(true))
        this.poiManager.update()
      }
    },

    fetchBrand() {
      this.$request.brands(0).then(resp => {
        if (resp.code == 0) {
          resp.data.forEach(i => {
            i.logo = getStaticPath(i.brandLogo)
          })
          this.brands = this.$utils.map(resp.data, 'id')
          this.ready = true
          this.fetchCompany()
        }
      })
    },
    fetchCompany(bounds) {
      this.ready = false
      let params = { search: { ...bounds }, pageSize: 1e6, pageNum: 1 }
      this.$request.companies(params).then(resp => {
        if (!resp.code) {
          this.companies = resp.data.list

          this.companies.forEach(i => {
            i.icon = this.brands[i.brandId] ? this.brands[i.brandId].logo : ''
            let t = wgs2gcj(i.longitude , i.latitude)
            i.longitude = t[0]
            i.latitude = t[1]
            i.courierTotal = i.courierTotal || 0
            i.carTotal = i.carTotal || 0
          })
          this.poiManager.load(this.companies)
          this.ready = true
        }
      })
    },
    handleModal() {
      setTimeout(this.update, 1000)
    },
    linkToCar(companyId){
      this.$router.setRouteByCode('car.map.new' , {query:{companyId}},true)
    }
  }
}

</script>
<style lang="scss" scoped="">
.map {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1001;
}
</style>
